import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
import {environment} from '../../../../../environments/environment';
import {VanBanDiXLService} from '../../../../service/vanbandi/service-vanbandixl';
import {Staffs} from '../../../../models/staff/staffs';
import {VanBanDi} from '../../../../models/vanbandi/vanbandi';
import {HoSo} from '../../../../models/hoso/hoso';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {HoSoService} from '../../../../service/hoso/service-hoso';

@Component({
  templateUrl: './chenhoso.component.html'

})
export class ChenHoSoVanBanDiComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public hoSoList: HoSo[];
  public status: number[]= [environment.hosocanhan];
  public srTuKhoa: string = '';
  public  onClose: Subject<boolean>;
  public vanBanDiItem: VanBanDi=new VanBanDi();
  constructor(
    public hoSoService: HoSoService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public commandUtils: CommandUtil,
    public vanBanDiService: VanBanDiService,
    public commandUtil: CommandUtil
  ) {
  }
  ngAfterViewInit() {

  }
  public search()
  {

    this.hoSoService.findAllByPaging(this.srTuKhoa, this.status.join(), Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(dataList => this.hoSoList = dataList);
    this.hoSoService.getCountByKeyword(this.srTuKhoa, this.status.join(), Sessioncommand.staffId).subscribe(recordCount => this.totalItems = recordCount);
  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number) {
    this.id= id;
    this.isEdit =(id!=0)? true: false;
    this.vanBanDiService.getById(id).subscribe(data => this.vanBanDiItem = data);

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.search();
  }

  public insertHoSo(hoSoId: number)
  {


    this.vanBanDiService.chenHoSo(this.id, hoSoId).subscribe(
      {    next: (data) => {
          this.toastr.success(language.dadinhkemfilevaohosothanhcong, language.message);
          this.search();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }

  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }
}

